import {useAppSelector} from "@/redux/hooks";
import {RootState} from "@/redux/store";

export default function useIsInRoles (targetRoles: string[]) {
    const roles = useAppSelector((state: RootState) => state.user.currentUser?.roles);
    return targetRoles.some(role => roles?.includes(role));
}